export default __webpack_public_path__ + "assets/img/1111_logo.svg";